import { FilterX } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface ClearFiltersButtonProps {
	onClick: () => void;
	className?: string;
}

/**
 * Shared clear-filters icon button used across filter bars.
 * Renders a ghost FilterX icon with destructive color styling.
 * Only render this when `hasActiveFilters` is true.
 */
export function ClearFiltersButton({ onClick, className = '' }: ClearFiltersButtonProps) {
	const { t } = useTranslation('common');

	return (
		<Button
			variant="ghost"
			size="icon"
			onClick={onClick}
			className={`h-8 w-8 hover:bg-muted/50 ${className}`}
			title={t('buttons.clearFilters')}
		>
			<FilterX className="h-4 w-4 text-destructive" />
		</Button>
	);
}
